/**
 * @desc 保存挂牌商品
 */
import { ListingEntity, ListingForm } from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type CreateListingParameter = ListingForm

const method = 'POST'
const url = '/trade/member/listing'

export const createListingApi = (
  data?: CreateListingParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<ListingEntity>({
    method,
    url,
    data,
    ...config
  })
}

createListingApi.method = method
createListingApi.url = url
